// extracted by mini-css-extract-plugin
module.exports = {"item":"Posts_item__3oz2J","info":"Posts_info__1jU6l"};